import React from 'react';
import { FragmentData, gql } from '@ts-gql/tag';
import { useMutation } from '@ts-gql/apollo';

import { Toggle } from '@reckon-web/toggle';
import { useToasts } from '@reckon-web/toast';

import { usersFragment } from '../UsersTable';

// gql
const fragment = gql`
  fragment User_Manager on TenantUser {
    __typename
    manager
  }
` as import('../../../../__generated__/ts-gql/User_Manager').type;

const UPDATE_MANAGER = gql`
  mutation UpdateTenantUserManager($input: TenantUserManagerInput!) {
    updateTenantUserManager(input: $input)
  }
` as import('../../../../__generated__/ts-gql/UpdateTenantUserManager').type;

// component
export function Manager({
  tenantUser,
  canEditUser,
}: {
  tenantUser: FragmentData<typeof usersFragment>;
  canEditUser?: boolean;
}) {
  const { addToast } = useToasts();
  const [updateManager] = useMutation(UPDATE_MANAGER);
  const onToggle = async () => {
    if (tenantUser.cloudId) {
      try {
        const data = await updateManager({
          variables: {
            input: {
              cloudId: tenantUser.cloudId,
              modifiedBy: 'TUM',
              manager: !tenantUser.manager,
            },
          },
          optimisticResponse: {
            __typename: 'Mutation',
            updateTenantUserManager: true,
          },
          update: (cache) => {
            cache.writeFragment({
              id: tenantUser.cloudId || '',
              fragment: fragment,
              data: {
                __typename: 'TenantUser',
                manager: !tenantUser.manager,
              },
            });
          },
        });
        addToast({
          tone: 'positive',
          title: 'Manager update success',
        });
        if (!data.data?.updateTenantUserManager) {
          addToast({
            tone: 'warning',
            title: "Something isn't right, please check the console",
          });
        }
      } catch (error: any) {
        let err = error?.message || error;
        if (err.includes('GraphQL error:'))
          err = err.replace('GraphQL error: ', '');
        addToast({
          tone: 'critical',
          title: `Update failed`,
          message: `${err}`,
        });
      }
    }
  };
  if (tenantUser.apsUserId === 0) {
    return <React.Fragment />;
  }

  return (
    <Toggle
      checked={tenantUser.manager || undefined}
      disabled={!canEditUser}
      onChange={onToggle}
    />
  );
}
